import { graphql, useStaticQuery, Link } from 'gatsby';
import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components';
import Branded from '../components/Branded';
import SEO from '../components/SEO';
import Footer from '../sections/Footer';

const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const bounceArrow = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(8px); }
`;

/* ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã‚ÂÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã‚ÂÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã‚ÂÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ Hero ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã‚ÂÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã‚ÂÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã‚ÂÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ */
const HeroSection = styled.section`
  position: relative;
  height: 100vh;
  min-height: 600px;
  overflow: hidden;
  background: #0b1f3a;

  .hero-media {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .hero-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(
      180deg,
      rgba(11, 31, 58, 0.85) 0%,
      rgba(11, 31, 58, 0.75) 100%
    );
    z-index: 1;
  }

  .hero-content {
    position: absolute;
    inset: 0;
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 0 24px;
  }

  .hero-tag {
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.24em;
    text-transform: uppercase;
    color: #f08020;
    margin-bottom: 28px;
    display: inline-flex;
    align-items: center;
    gap: 14px;
    animation: ${fadeUp} 0.9s ease 0s both;

    &::before,
    &::after {
      content: '';
      width: 32px;
      height: 1px;
      background: rgba(240, 128, 32, 0.6);
    }
  }

  .hero-title {
    font-size: clamp(2.4rem, 6vw, 5rem);
    font-weight: 700;
    color: #fff;
    line-height: 1.1;
    letter-spacing: -0.01em;
    margin: 0 0 32px;
    animation: ${fadeUp} 0.9s ease 0.1s both;
  }

  .hero-arrow {
    position: absolute;
    bottom: 56px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
    color: rgba(255, 255, 255, 0.85);
    animation: ${bounceArrow} 2s ease-in-out infinite;

    svg {
      width: 28px;
      height: 28px;
      stroke: currentColor;
      fill: none;
      stroke-width: 1.4;
      stroke-linecap: round;
      stroke-linejoin: round;
    }
  }
`;

/* ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã‚ÂÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã‚ÂÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã‚ÂÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ Service Categories ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã‚ÂÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã‚ÂÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã‚ÂÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ */
const ServicesSection = styled.section`
  background: #fff;
`;

const ServiceBlock = styled.article`
  position: relative;
  display: grid;
  grid-template-columns: 1.05fr 1fr;
  align-items: center;
  max-width: 1320px;
  margin: 0 auto;
  padding: 120px 56px;
  gap: 96px;
  background: ${({ alt }) => (alt ? '#F8FAFC' : '#fff')};

  @media (max-width: 1024px) {
    padding: 80px 40px;
    gap: 56px;
  }

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    padding: 64px 24px;
    gap: 32px;
  }

  /* Even blocks: content on left, image on right (reversed) */
  &:nth-child(even) {
    .block-image {
      order: 2;
      @media (max-width: 900px) {
        order: 1;
      }
    }
    .block-content {
      order: 1;
      @media (max-width: 900px) {
        order: 2;
      }
    }

    .block-num {
      right: auto;
      left: 8%;
      @media (max-width: 900px) {
        left: 24px;
      }
    }
  }

  /* Big watermark number */
  .block-num {
    position: absolute;
    top: 48px;
    right: 8%;
    font-size: clamp(80px, 12vw, 180px);
    font-weight: 800;
    line-height: 1;
    color: transparent;
    -webkit-text-stroke: 1px rgba(19, 120, 229, 0.15);
    letter-spacing: -0.04em;
    pointer-events: none;
    user-select: none;
    z-index: 0;

    @media (max-width: 900px) {
      top: 24px;
      right: 24px;
      font-size: 90px;
    }
  }

  .block-image {
    position: relative;
    overflow: hidden;
    aspect-ratio: 4 / 5;
    background: #f2f6fc;
    z-index: 1;
    box-shadow: 0 28px 60px rgba(11, 31, 58, 0.12);

    @media (max-width: 900px) {
      aspect-ratio: 4 / 3;
    }

    &::after {
      content: '';
      position: absolute;
      inset: auto -14px -14px auto;
      width: 60%;
      height: 60%;
      border: 1px solid #f08020;
      z-index: -1;
      pointer-events: none;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
      transition: transform 0.7s cubic-bezier(0.16, 1, 0.3, 1);
    }

    &:hover img {
      transform: scale(1.04);
    }
  }

  .block-placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #5b6b7c;
    font-size: 13px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
  }

  .block-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    z-index: 1;
  }

  .block-eyebrow {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.24em;
    text-transform: uppercase;
    color: #f08020;
    margin-bottom: 20px;
    display: inline-flex;
    align-items: center;
    gap: 14px;

    &::before {
      content: '';
      width: 32px;
      height: 1px;
      background: #f08020;
    }
  }

  .block-title {
    font-size: clamp(2rem, 3.8vw, 3.2rem);
    font-weight: 700;
    color: #0b1f3a;
    line-height: 1.1;
    letter-spacing: -0.015em;
    margin: 0 0 24px;
  }

  .block-desc {
    font-size: 16px;
    color: #4a5868;
    line-height: 1.85;
    font-weight: 300;
    white-space: pre-line;
    margin: 0 0 36px;
    max-width: 540px;

    @media (max-width: 768px) {
      font-size: 14.5px;
    }
  }

  .features-heading {
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: #1378e5;
    margin: 0 0 20px;
    padding-bottom: 16px;
    border-bottom: 1px solid #e2e8f0;
  }
`;

const FeatureList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px 24px;
  max-width: 540px;

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

const FeatureItem = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  font-size: 14px;
  color: #1b2733;
  line-height: 1.55;
  font-weight: 400;

  @media (max-width: 768px) {
    font-size: 13.5px;
  }

  .check {
    flex-shrink: 0;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: rgba(240, 128, 32, 0.12);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-top: 1px;

    svg {
      width: 12px;
      height: 12px;
      stroke: #f08020;
      fill: none;
      stroke-width: 2.4;
      stroke-linecap: round;
      stroke-linejoin: round;
    }
  }
`;

/* ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã‚ÂÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã‚ÂÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã‚ÂÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ FAQ ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã‚ÂÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã‚ÂÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã‚ÂÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ */
const FaqSection = styled.section`
  background: #fff;
  padding: 112px 24px 128px;

  @media (max-width: 768px) {
    padding: 72px 20px 88px;
  }

  .faq-inner {
    max-width: 1120px;
    margin: 0 auto;
  }
`;

const FaqList = styled.div`
  display: flex;
  flex-direction: column;
`;

const FaqRow = styled.div`
  position: relative;
  background: ${({ open }) => (open ? '#fff' : 'transparent')};
  box-shadow: ${({ open }) =>
    open ? '0 18px 44px rgba(19, 120, 229, 0.08)' : 'none'};
  border-radius: ${({ open }) => (open ? '4px' : '0')};
  border: ${({ open }) => (open ? '1px solid rgba(240, 128, 32, 0.45)' : '0')};
  transition: background 0.25s ease, box-shadow 0.25s ease,
    border-color 0.25s ease;

  & + & {
    border-top: ${({ open }) =>
      open ? '1px solid rgba(240, 128, 32, 0.45)' : '1px solid #D8E1EC'};
  }

  &:has(+ ${'div[data-open="true"]'}) {
    border-bottom-color: transparent;
  }
`;

const FaqQuestion = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 28px 32px;
  background: transparent;
  border: 0;
  font-size: clamp(15px, 1.2vw, 18px);
  font-weight: 500;
  text-align: left;
  cursor: pointer;
  color: ${({ open }) => (open ? '#F08020' : '#1378E5')};
  transition: color 0.25s ease;

  &:hover {
    color: ${({ open }) => (open ? '#F08020' : '#4A99EC')};
  }

  @media (max-width: 768px) {
    padding: 22px 20px;
    gap: 16px;
  }

  .icon {
    flex-shrink: 0;
    width: 30px;
    height: 30px;
    border: 1.5px solid ${({ open }) => (open ? '#F08020' : '#1378E5')};
    border-radius: 50%;
    position: relative;
    transition: border-color 0.25s ease;

    &::before,
    &::after {
      content: '';
      position: absolute;
      inset: 0;
      margin: auto;
      background: ${({ open }) => (open ? '#F08020' : '#1378E5')};
      transition: transform 0.25s ease, background 0.25s ease;
    }
    &::before {
      width: 12px;
      height: 1.5px;
    }
    &::after {
      width: 1.5px;
      height: 12px;
      transform: ${({ open }) => (open ? 'scaleY(0)' : 'scaleY(1)')};
    }
  }
`;

const FaqAnswer = styled.div`
  max-height: ${({ open }) => (open ? '600px' : '0')};
  opacity: ${({ open }) => (open ? '1' : '0')};
  overflow: hidden;
  transition: max-height 0.4s ease, opacity 0.3s ease;

  .answer-inner {
    padding: 0 32px 28px;
    font-size: 15px;
    color: #1b2733;
    line-height: 1.85;
    white-space: pre-line;
    max-width: 88%;

    @media (max-width: 768px) {
      padding: 0 20px 22px;
      font-size: 14px;
      max-width: 100%;
    }
  }
`;

/* ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã‚ÂÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã‚ÂÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã‚ÂÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ CTA ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã‚ÂÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã‚ÂÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã‚ÂÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ */
const CtaSection = styled.section`
  position: relative;
  overflow: hidden;
  background: #1378e5;
  min-height: 460px;
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    min-height: 380px;
  }

  .cta-bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    z-index: 0;
  }

  .cta-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(
      to right,
      rgba(11, 93, 184, 0.92) 0%,
      rgba(19, 120, 229, 0.85) 60%,
      rgba(19, 120, 229, 0.75) 100%
    );
    z-index: 1;
  }

  .cta-inner {
    position: relative;
    z-index: 2;
    width: 100%;
    max-width: 1320px;
    margin: 0 auto;
    padding: 96px 56px;

    @media (max-width: 1024px) {
      padding: 80px 40px;
    }

    @media (max-width: 768px) {
      padding: 64px 24px;
    }
  }

  .cta-title {
    font-size: clamp(1.8rem, 4vw, 3.2rem);
    font-weight: 700;
    color: #fff;
    line-height: 1.2;
    letter-spacing: -0.01em;
    margin: 0 0 44px;
    max-width: 760px;

    @media (max-width: 768px) {
      margin-bottom: 32px;
    }
  }
`;

const CtaButton = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 18px;
  font-size: 15px;
  font-weight: 500;
  color: #fff;
  border: 1.5px solid #f08020;
  border-radius: 999px;
  padding: 18px 36px;
  background: #f08020;
  cursor: pointer;
  text-decoration: none;
  transition: background 0.3s ease, color 0.3s ease, border-color 0.3s ease;

  .dash {
    display: inline-block;
    width: 18px;
    height: 1.5px;
    background: currentColor;
    flex-shrink: 0;
  }

  &:hover {
    background: #c95e0f;
    color: #fff;
    border-color: #c95e0f;
  }

  @media (max-width: 768px) {
    padding: 14px 28px;
    font-size: 14px;
    gap: 14px;

    .dash {
      width: 14px;
    }
  }
`;

const servicesQuery = graphql`
  {
    sanityServicesPage {
      heroTag
      heroTitle
      heroImage {
        asset {
          _id
          url
        }
      }
      services {
        _key
        title
        description
        featuresHeading
        features
        icon {
          asset {
            _id
            url
          }
        }
      }
      seoTitle
      seoDescription
    }
    sanityServicesFaqSection {
      faqTag
      faqTitle
      faqs {
        _key
        question
        answer
      }
    }
    sanityServicesCtaSection {
      ctaTitle
      ctaButtonLabel
      ctaButtonLink
      ctaBackgroundImage {
        asset {
          _id
          url
        }
      }
    }
  }
`;

export default function ServicesPage() {
  const data = useStaticQuery(servicesQuery);
  const page = data?.sanityServicesPage;
  const faqSection = data?.sanityServicesFaqSection;
  const ctaSection = data?.sanityServicesCtaSection;
  const services = page?.services || [];
  const faqs = faqSection?.faqs || [];

  const [openIdx, setOpenIdx] = useState(0);

  return (
    <div>
      <SEO
        title={page?.seoTitle || 'Services - Decorzo Space'}
        description={page?.seoDescription}
      />

      {/* Hero */}
      <HeroSection>
        {page?.heroImage?.asset?.url && (
          <img
            className="hero-media"
            src={page.heroImage.asset.url + '?w=1920&auto=format'}
            alt={page?.heroTitle || ''}
          />
        )}
        <div className="hero-overlay" />
        <div className="hero-content">
          {page?.heroTag && <div className="hero-tag">{page.heroTag}</div>}
          {page?.heroTitle && <h1 className="hero-title">{page.heroTitle}</h1>}
        </div>
        <div className="hero-arrow" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path d="M12 5v14M5 12l7 7 7-7" />
          </svg>
        </div>
      </HeroSection>

      {/* Service Categories */}
      {services.length > 0 && (
        <ServicesSection>
          {services.map((item, idx) => {
            const img = item.icon?.asset?.url;
            const features = item.features || [];
            return (
              <ServiceBlock key={item._key} alt={idx % 2 === 1}>
                <span className="block-num" aria-hidden="true">
                  {String(idx + 1).padStart(2, '0')}
                </span>
                <div className="block-image">
                  {img ? (
                    <img
                      src={img + '?w=1200&auto=format'}
                      alt={item.title || ''}
                      loading="lazy"
                    />
                  ) : (
                    <div className="block-placeholder">Image</div>
                  )}
                </div>
                <div className="block-content">
                  <div className="block-eyebrow">
                    Service {String(idx + 1).padStart(2, '0')}
                  </div>
                  <Branded as="h2" className="block-title" text={item.title} />
                  <Branded
                    as="p"
                    className="block-desc"
                    text={item.description}
                  />
                  {item.featuresHeading && (
                    <h3 className="features-heading">{item.featuresHeading}</h3>
                  )}
                  {features.length > 0 && (
                    <FeatureList>
                      {features.map((f, i) => (
                        <FeatureItem key={i}>
                          <span className="check" aria-hidden="true">
                            <svg viewBox="0 0 24 24">
                              <path d="M5 12l5 5L20 7" />
                            </svg>
                          </span>
                          <span>{f}</span>
                        </FeatureItem>
                      ))}
                    </FeatureList>
                  )}
                </div>
              </ServiceBlock>
            );
          })}
        </ServicesSection>
      )}

      {/* FAQ */}
      {faqs.length > 0 && (
        <FaqSection>
          <div className="faq-inner">
            <FaqList>
              {faqs.map((faq, idx) => {
                const isOpen = openIdx === idx;
                return (
                  <FaqRow
                    key={faq._key || idx}
                    open={isOpen}
                    data-open={isOpen}
                  >
                    <FaqQuestion
                      open={isOpen}
                      onClick={() => setOpenIdx(isOpen ? -1 : idx)}
                      aria-expanded={isOpen}
                    >
                      <span>{faq.question}</span>
                      <span className="icon" aria-hidden="true" />
                    </FaqQuestion>
                    <FaqAnswer open={isOpen}>
                      <Branded
                        as="div"
                        className="answer-inner"
                        text={faq.answer}
                      />
                    </FaqAnswer>
                  </FaqRow>
                );
              })}
            </FaqList>
          </div>
        </FaqSection>
      )}

      {/* CTA */}
      {(ctaSection?.ctaTitle || ctaSection?.ctaButtonLabel) && (
        <CtaSection>
          {ctaSection?.ctaBackgroundImage?.asset?.url && (
            <img
              className="cta-bg"
              src={
                ctaSection.ctaBackgroundImage.asset.url + '?w=1920&auto=format'
              }
              alt=""
              loading="lazy"
            />
          )}
          <div className="cta-overlay" />
          <div className="cta-inner">
            {ctaSection?.ctaTitle && (
              <h2 className="cta-title">{ctaSection.ctaTitle}</h2>
            )}
            {ctaSection?.ctaButtonLabel &&
              (() => {
                const link = ctaSection?.ctaButtonLink || '/contact';
                const isExternal = /^https?:\/\//.test(link);
                const inner = (
                  <>
                    <span className="dash" aria-hidden="true" />
                    <span>{ctaSection.ctaButtonLabel}</span>
                  </>
                );
                if (isExternal) {
                  return (
                    <CtaButton
                      as="a"
                      href={link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {inner}
                    </CtaButton>
                  );
                }
                return (
                  <CtaButton as={Link} to={link}>
                    {inner}
                  </CtaButton>
                );
              })()}
          </div>
        </CtaSection>
      )}

      <Footer />
    </div>
  );
}
